const common = {
  siteName: '韩漫免费网站',
  siteDescription: '韩漫免费网站，汇聚韩国漫画大全，提供无删减韩漫在线免费观看，高清画质流畅阅读体验',
  readNow: '立即阅读',
  viewMore: '查看更多',
  hotRecommend: '热门推荐',
  latestUpdate: '最新更新',
  categoryNav: '分类导航',
  allCategories: '全部分类',
  home: '首页',
  category: '分类',
  about: '关于我们',
  contact: '联系我们',
  search: '搜索',
  login: '登录',
  chapter: '话',
  latestChapter: '最新话',
 连载中: '连载中',
 已完结: '已完结',
  views: '阅读',
  rating: '评分',
  author: '作者',
  status: '状态',
  description: '简介',
  chapterList: '章节列表',
  comment: '评论',
  relatedRecommend: '相关推荐',
  brandIntro: '品牌介绍',
  reputation: '口碑声誉',
  contactInfo: '联系方式',
  footerCopyright: '© 2026 韩漫免费网站 版权所有',
  privacyPolicy: '隐私政策',
  termsOfService: '服务条款',
  siteMap: '网站地图',
  subscribeNewsletter: '订阅更新',
  emailPlaceholder: '请输入您的邮箱',
  subscribe: '订阅',
  ourAddress: '我们的地址',
  contactPhone: '联系电话',
  contactEmail: '联系邮箱',
  followUs: '关注我们',
  startReading: '开始阅读',
  discoverMore: '发现更多',
  backToHome: '返回首页',
  loading: '加载中...',
  noMoreData: '没有更多了',
};

export default common;